<div class="dialog-entry">
    <ng-content></ng-content>
</div>
